import React from 'react'
import Grid from '@material-ui/core/Grid'
import { makeStyles } from '@material-ui/core/styles'
import Forms from 'components/forms'
import { useMergedState } from 'hooks'
import Request from 'api'
import JsonForm from './mock'

const style = makeStyles(theme => ({
  cancelButton: {
    marginRight: theme.spacing(2),
  },
  form: {
    paddingTop: theme.spacing(1.5),
  },
}))

export default function DesactivationForm({
  onCloseModal,
  role,
  experienceId,
  setMessage,
  refreshPage,
}) {
  const classes = style()
  const requestPrefix = role.toLowerCase()
  const [{ loading, error }, setState] = useMergedState({
    loading: false,
    error: null,
  })

  function haddleOnCLick({ desactivationReason }) {
    if (!loading) {
      setState({ loading: true })
      const desactivation = new Request({
        endpoint: `${requestPrefix}Desactivate`,
        params: {
          experienceId,
          activate: false,
          desactivationReason,
        },
      })
      desactivation
        .send()
        .then(({ message }) => {
          setMessage(message, `success`)
        })
        .catch(({ message }) => {
          setMessage(message)
        })
        .finally(() => refreshPage())
    }
  }

  return (
    <Grid container className={classes.form}>
      <Forms
        classes={classes}
        sections={JsonForm.sections.fieldsIds}
        fieldsById={JsonForm.fieldsById}
        submitForm={haddleOnCLick}
        loading={loading}
        onCancel={onCloseModal}
        cancelText="Cancelar"
        acceptText="Enviar respuesta"
        error={error}
        buttonsSize="medium"
        buttonsFullWidth={false}
      />
    </Grid>
  )
}
